/**
 * Toggles fixed header collapsing on scroll.
 * Saves current and previous scroll position on scroll.
 * Checks if scrolling down and scroll position is past 100px.
 * If so, adds collapsed class to header and body.
 * Checks if scrolling up.
 * If so, removes collapsed class from header and body.
 * Sets newScrollPosition to lastScrollPosition after scroll.
*/
const stickyHeaderToggler = function () {
  let newScrollPosition = 0;
  let lastScrollPosition;
  const header = document.querySelector("header");
  const body = document.querySelector("body");

  window.addEventListener("scroll", function () {
    lastScrollPosition = window.scrollY;
    // Scrolling down
    if (newScrollPosition < lastScrollPosition && lastScrollPosition > 100) {
      header.classList.add("collapsed");
      body.classList.add("header-collapsed");
      // Scrolling up
    } else if (newScrollPosition > lastScrollPosition) {
      header.classList.remove("collapsed");
      body.classList.remove("header-collapsed");
    }
    newScrollPosition = lastScrollPosition;
  });
};
stickyHeaderToggler();
